import { Toolbar } from "primereact/toolbar";
import {ILogin, IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IModal } from "./Docs";
import { Fetch } from "../../shared/Fetch";
import { format } from "date-fns";
import { safeFormatDate } from "../../models/DateFormatMapper";

export interface IDocs {
    id?: number,
    title?: string,
    discription?: string,
    url?: string,
    status?: boolean,
    updated_at?: Date | null,
    updated_by?: number | null,
    created_at?: Date | null,
    created_by?: number | null,

};
interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyDocs = {
    title: "",
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IDocs>, loading: boolean });
    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (

            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Docs</h5>
        </div>
    );

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyDocs });
    };
    const openEdit = (rowData: IDocs) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const action = (rowData: IDocs) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Docs_Module", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const CreatedON = (rowData: any) => {
        let date;
        if (rowData.created_at) date = format(new Date(rowData.created_at), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const Updatedon = (rowData: any) => {
        let date;
        if (rowData.updated_at) date = format(new Date(rowData.updated_at), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);
    
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DataFormat = loginObj.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Records found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="title" header="Title" />
                <Column field="discription" header="Discription" />
                <Column field="url" header="URL" body={(rowData) => (rowData.url ? (
                    <a href={rowData.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                        {rowData.url}
                    </a>) : ("N/A"))} />
                {/* <Column field="created_at" header="Created On" body={CreatedON}/> */}
                 <Column field="created_at" header="Created On" body={(rowData: any) => safeFormatDate(rowData.created_at, "dd/MM/yyyy", DataFormat)}/>
                <Column field="created_by_name" header="Created By" />
                {/* <Column field="updated_at" header="Updated On" body={Updatedon} /> */}
                <Column field="updated_at" header="Updated On" body={(rowData: any) =>safeFormatDate(rowData.updated_at, 'dd/MM/yyyy', DataFormat)} />
                <Column field="updated_by_name" header="Updated By" />
                <Column field="" header="Action" body={action} />
            </DataTable>
        </>
    );
}